/**
 * @generated SignedSource<<103c70589329ced401f9f0237947e22d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaEditor_mediable$data = {
  readonly id: string;
  readonly media: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"MediaEditorPreviews_media" | "MediaEditorSort_media">;
  };
  readonly " $fragmentType": "MediaEditor_mediable";
};
export type MediaEditor_mediable$key = {
  readonly " $data"?: MediaEditor_mediable$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaEditor_mediable">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "media"
        ]
      }
    ]
  },
  "name": "MediaEditor_mediable",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "media",
      "args": null,
      "concreteType": "MediaConnection",
      "kind": "LinkedField",
      "name": "__MediaEditor_mediable_media_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Media",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MediaEditorPreviews_media"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MediaEditorSort_media"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Mediable",
  "abstractKey": "__isMediable"
};
})();

(node as any).hash = "f39fc97cc18eda78e935a9955fc33e58";

export default node;
